import React from "react";

export interface ModuleHexProps {
  /** Accent color for the module's front face of the hex cube. */
  accent: string;
  /** Rendered square size in px. */
  size?: number;
}

/**
 * The Topcon hexagonal-cube brand mark, with a per-module accent face.
 * Three faces are fixed brand navy / navy-medium; the front face takes the accent.
 */
const ModuleHex: React.FC<ModuleHexProps> = ({ accent, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0, display: "block" }}
    aria-hidden="true"
  >
    <path d="M70.326 102.749L53.2528 74.5244H19.4961L36.5463 102.749H70.326Z" fill="#003563" />
    <path d="M80.4547 28.2247L63.4045 0H29.625L46.6982 28.2247H80.4547Z" fill="#003563" />
    <path
      d="M46.6766 28.2245L19.4972 74.5459C16.0483 74.545 12.6614 73.6276 9.68175 71.8872C6.7021 70.1469 4.23615
        67.6458 2.5356 64.639C0.835036 61.6321 -0.0394137 58.2273 0.00136359 54.7713C0.042139 51.3154 0.996757
        47.9321 2.76779 44.9664L29.6264 0L46.6766 28.2245Z"
      fill="#2968A8"
    />
    <path
      d="M53.3008 74.547L80.5032 28.2256C83.952 28.2265 87.3389 29.1439 90.3187 30.8843C93.2983 32.6246 95.7642
        35.1259 97.4648 38.1326C99.1652 41.1394 100.04 44.5443 99.9988 48.0002C99.9581 51.4562 99.0036 54.8394
        97.2325 57.8051L70.3509 102.772L53.3008 74.547Z"
      fill="#2968A8"
    />
    <path d="M80.4552 28.2256L53.2528 74.524H19.4961L46.6985 28.2256H80.4552Z" fill={accent} />
  </svg>
);

ModuleHex.defaultProps = {
  size: 40
};

export default ModuleHex;
